/* What the AC balancer's stage means, in words: [headline, why]. Shared by the
 * Environment page and the Dashboard so both describe the AC the same way. */
export const STAGE_TEXT = {
  hold: ['On target', 'The container is on goal. The AC runs on its own thermostat.'],
  ease_off: ['On target', 'The container is slightly under goal, so there is nothing to cool.'],
  gentle_cool: ['A little warm', 'Slightly warm. Fan is up; the setpoint stays at goal.'],
  strong_cool: ['Warm, cooling', 'Clearly warm. Setpoint is 2° under goal.'],
  max_cool: ['Hot, maximum cooling', 'Far above goal. 16 °C with turbo.'],
  gradient_limited: ['Limited by airflow', 'The back end is already cold; cooling harder would only punish it. Move more air to the front.'],
};
